import React, { useState } from "react"
//import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import LogoAvalith from "../../images/avalith-logo-white.svg"
import BgWorkTravelImg from "../../images/team-work.png"
import ITRecruiterImg from "../../images/promo/skill-factory-it-recruiter/IT-recruiter.svg"
import LupaImg from "../../images/promo/skill-factory-it-recruiter/Lupa.svg"
import PcImg from "../../images/promo/skill-factory-it-recruiter/Pc.svg"
import FormSpecial from "../../components/Promos/SkillFactoryItRecruter/FormSpecial"
import PreviewImg from "../../images/preview-skillfactory.png"
import { postPosition } from "../../components/Promos/SkillFactoryItRecruter/positions-79953"

const SkillFactoryItRecrutier = () => {
  const [fullName, setFullName] = useState("")
  const [email, setEmail] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [linkedin, setLinkedin] = useState("")
  const [resume, setResume] = useState("")
  const [message, setMessage] = useState("")
  const [isSentForm, setIsSentForm] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isCaptcha, setIsCaptcha] = useState(false)

  const handleSubmit = async evt => {
    evt.preventDefault()
    setLoading(true)

    try {
      const formData = new FormData()
      formData.append("full_name", fullName)
      formData.append("email", email)
      formData.append("phone_number", phoneNumber)
      formData.append("resume", resume)
      formData.append("linkedin", linkedin)
      formData.append("message", message)

      if (isCaptcha) {
        await postPosition(formData)
        // Display the values
        for (var value of formData.values()) {
          console.log(value)
        }
      }

      setIsSentForm(true)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const handleChangeUploadResume = evt => {
    const file = evt.target.files[0]
    setResume(file)
  }

  const veryfyCaptcha = captchaValue => {
    if (captchaValue !== null && captchaValue !== undefined) {
      setIsCaptcha(true)
    } else {
      setIsCaptcha(false)
    }
  }

  return (
    <div className="font-body subpixel-antialiased dark:bg-primary dark:text-white transform duration-500">
      <SEO
        title="Skill Factory IT Recruiter"
        description="Dejanos tus datos para que nuestro equipo de la Skill Factory evalue la postulación al curso. Curso totalmente gratis, cupos limitados."
        siteImage={PreviewImg}
      />
      <section
        className="bg-cover bg-no-repeat bg-center text-white"
        style={{ backgroundImage: `url(${BgWorkTravelImg})` }}
      >
        <div className="px-6 pt-12 bg-primary bg-opacity-75">
          <div className="container mx-auto items-center text-center pb-8">
            <img src={LogoAvalith} alt="Avalith" className="py-16 inline" />
            <h1 className="text-6xl lg:text-8xl pb-8 font-bold">
              <span className="text-secondary">Skill </span>Factory IT
              <br />
              <span className="font-normal">Recruiter</span>
            </h1>
            <h4 className="text-3xl pb-4">
              Fecha de Inicio
              <br /><br />
              <span className="text-5xl">01/03/2021</span>
            </h4>
          </div>
          <hr />
          <p className="py-8 text-xl text-center">
            Déjanos tus datos para que nuestro equipo de Skill Factory evalue
            tu postulación.
          </p>
        </div>
      </section>
      <div className="bg-secondary">
        <p className="container mx-auto text-center text-white py-8 text-3xl font-light">
          <b>100% gratis</b>, cupos limitados.
        </p>
      </div>
      {/* content */}
      <section className="container mx-auto px-6">
        <div className="text-center pt-16 font-bold">
          <h2 className="text-6xl">Skill Factory</h2>
          <h3 className="text-secondary text-4xl">IT Recruiters</h3>
        </div>
        <div className="flex flex-wrap items-center pb-8">
          <div className="w-full md:w-1/2">
            <img
              src={ITRecruiterImg}
              alt="SkillFactoryLead"
              width="500"
              className="mx-auto pb-8 px-6"
            />
          </div>
          <div className="w-full md:w-1/2 font-semibold">
            <h4 className="pb-4 text-5xl">Framework de aprendizaje</h4>
            <h5 className="text-secondary pb-4 text-3xl">#SkillFactoryLead</h5>
            <p className="text-3xl">Coordina y desarrolla tu plan de estudio</p>
          </div>
        </div>

        <div className="flex flex-wrap-reverse items-center pb-8">
          <div className="w-full md:w-1/2">
            <p className="text-3xl leading-tight">
              El objetivo de esta experiencia es ofrecer a nuestros skillers las <b>herramientas necesarias</b> para poder <b>buscar, evaluar y reclutar</b> a talentos y profesionales de la <b>industria IT</b>.
            </p>
          </div>
          <div className="w-full md:w-1/2">
            <img src={LupaImg} alt="SkillFactoryLead" className="mx-auto pb-8 px-6" />
          </div>
        </div>

        <div className="flex flex-wrap items-center pb-8">
          <div className="w-full md:w-1/2">
            <img src={PcImg} alt="SkillFactoryLead" className="mx-auto pb-8 px-6" />
          </div>
          <div className="w-full md:w-1/2">
            <p className="text-3xl leading-tight">
              Si tienes conocimientos básicos sobre el funcionamiento de áreas de
              RRHH, nuestra <b>#SkillFactory #ItRecruiters</b>, Inscríbete y <b>continúa
              creciendo!</b>
            </p>
          </div>
        </div>
      </section>
      <section className="bg-primary text-white">
        <div className="container mx-auto px-6 py-20">
          {isSentForm ? (
            <div className="text-center text-2xl h-80 pt-24">
              Formulario enviado exitosamente !!<br />
              Regresar a <a href="https://www.avalith.net" title="avalith.net" className="text-secondary underline">avalith.net</a>
            </div>
          ) : (
            <>
              <h2 className="text-5xl font-semibold text-center pb-20 leading-snug">
                ¿Estás listo para capacitarte como{" "}
                <span className="text-secondary">IT Recruiter</span>?
              </h2>
              <FormSpecial
                handleSubmit={handleSubmit}
                fullName={fullName}
                setFullName={setFullName}
                email={email}
                setEmail={setEmail}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                linkedin={linkedin}
                setLinkedin={setLinkedin}
                resume={resume}
                handleChangeUploadResume={handleChangeUploadResume}
                message={message}
                setMessage={setMessage}
                loading={loading}
                isCaptcha={isCaptcha}
                veryfyCaptcha={veryfyCaptcha}
              />
            </>
          )}
        </div>
      </section>
    </div>
  )
}

export default SkillFactoryItRecrutier
